export default {
  MuiTablePagination: {
    styleOverrides: {
      root: {
        overflow: 'hidden'
      },
      toolbar: {
        minHeight: '0px !important',
        paddingRight: '0px !important',
        paddingLeft: '0px !important'
      },
      caption: {
        marginBottom: '5px'
      },
      actions: {
        marginLeft: '0px',
        '& > button:first-of-type': {
          padding: '0px',
          marginLeft: '8px'
        },
        '& > button:last-child': {
          padding: '0px',
          marginLeft: '8px'
        },
        '& > button:first-of-type > svg': {
          fontSize: '20px'
        },
        '& > button:last-child > svg': {
          fontSize: '20px'
        }
      },
      displayedRows: {
        margin: '0px'
      }
    }
  }
};
